import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { addToast } from "@/core/lib/toast";
import type { InferHeyApiMutationOptions } from "@/core/lib/types";
import {
  createTopicMutation,
  deleteTopicMutation,
  getTopicsOptions,
  getTopicsQueryKey,
  updateTopicMutation,
} from "@/openapi/@tanstack/react-query.gen";
import { m } from "@/paraglide/messages";

export function useTopics() {
  return useQuery({
    ...getTopicsOptions(),
  });
}

export function useCreateTopic(
  options: InferHeyApiMutationOptions<typeof createTopicMutation> = {},
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...createTopicMutation(),
    ...options,
    meta: { errorMessage: m.toast_topic_create_failed },
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getTopicsQueryKey(),
      });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
      addToast({
        title: m.toast_topic_create_success(),
        severity: "success",
        duration: 2500,
      });
    },
  });
}

export function useUpdateTopic(
  options: InferHeyApiMutationOptions<typeof updateTopicMutation> = {},
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...updateTopicMutation(),
    ...options,
    meta: { errorMessage: m.toast_topic_update_failed },
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getTopicsQueryKey(),
      });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
      addToast({
        title: m.toast_topic_update_success(),
        severity: "success",
        duration: 2500,
      });
    },
  });
}

export function useDeleteTopic(
  options: InferHeyApiMutationOptions<typeof deleteTopicMutation> = {},
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...deleteTopicMutation(),
    ...options,
    meta: { errorMessage: m.toast_topic_delete_failed },
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getTopicsQueryKey(),
      });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
      addToast({
        title: m.toast_topic_delete_success(),
        severity: "success",
        duration: 2500,
      });
    },
  });
}
